import { colors } from '@apollo/brand';
import { useMemo } from 'react';

import { HeatmapStackConfig } from 'src/components/charts/Heatmap';
import { HistogramBucket } from 'src/components/charts/helpers/histogram';
import { useStackInfo } from 'src/components/charts/helpers/useStackInfo';
import { decodeSparseBuckets } from 'src/lib/decodeSparseBuckets';
import { Timestamp } from 'src/lib/graphqlTypes/customScalarTypes';

export interface FieldHeatMapStackData {
  timestamp: Timestamp['output'];
  metrics: {
    fieldHistogram: {
      sparseBuckets: number[];
    };
  };
}
export const useFieldHeatmapStackInfo = (
  data: FieldHeatMapStackData[] | undefined,
) =>
  useStackInfo<
    FieldHeatMapStackData,
    { timestamp: Timestamp['output']; buckets: HistogramBucket[] },
    HeatmapStackConfig<FieldHeatMapStackData>
  >(
    useMemo(
      (): MinLengthArray<1, HeatmapStackConfig<FieldHeatMapStackData>> => [
        {
          primaryColor: colors.primitives.blue[300],
          data: data || [],
          getValue: (stats: FieldHeatMapStackData) => ({
            timestamp: stats.timestamp,
            buckets: decodeSparseBuckets(
              stats.metrics.fieldHistogram.sparseBuckets,
            ),
          }),
          hasData: (stats: FieldHeatMapStackData) =>
            stats.metrics.fieldHistogram.sparseBuckets.some((v) => v > 0),
          label: 'Requests',
          unit: ' RPM',
        },
      ],
      [data],
    ),
  );
